import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export type ShopTier = 'free' | 'founding' | 'pro';

export interface ShopTierInfo {
  tier: ShopTier;
  billingStatus: string;
  paidUntil: string | null;
  foundingNumber: number | null;
  tierStartedAt: string | null;
  timezone: string;
  atRiskDays: number;
}

async function fetchShopTier(shopId: string): Promise<ShopTierInfo | null> {
  const { data, error } = await supabase
    .from('shops_billing')
    .select('effective_tier, billing_status, paid_until, founding_number, tier_started_at, timezone, at_risk_days')
    .eq('id', shopId)
    .single();
  if (error || !data) return null;
  return {
    tier: data.effective_tier as ShopTier,
    billingStatus: data.billing_status,
    paidUntil: data.paid_until,
    foundingNumber: data.founding_number,
    tierStartedAt: data.tier_started_at,
    timezone: data.timezone,
    atRiskDays: data.at_risk_days,
  };
}

export function useShopTier(shopId: string | null) {
  return useQuery({
    queryKey: ['shop-tier', shopId],
    queryFn: () => fetchShopTier(shopId!),
    enabled: !!shopId,
    staleTime: 5 * 60 * 1000,
  });
}
